<template>
  <div id="Vitals-form">
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 text-center">
          <h5 class="text-primary">Select vital to capture</h5>
        </div>
      </div>

      <div class="row" style="margin-top: 2em">
        <div class="col-sm-12 col-md-6 col-lg-4" :id="device.identifier" v-if="device" style="margin-bottom:3em">
          <patient-vital-card :deviceforcard="device" :vitals="device.vitals" :vital-index="0" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :historic-vitals="historicVitals" :allowManualEntry="true" :allowRetrieval="IS_PATIENT" :shareButton="false" :uploadButton="true" :vital-group="false" @fetchHistoricVitals="fetchHistoricVitals"></patient-vital-card>
        </div>

        <div v-show="device && device.vitalsGroup && showVitalsGroups" class="col-sm-12 col-md-6 col-lg-4" :id="device.identifier" style="margin-bottom:3em" v-for="group in  device.vitalsGroup" :key="group.identifier">
          <patient-vital-card :deviceforcard="device" :vitals="group.vitals" :vital-index="0" ref="vitalComponents" v-if="device.communication.communicationMethod != 'NOTIFY'" :error-messages="errorMessages" :historic-vitals="historicVitals" :allowManualEntry="true" :allowRetrieval="IS_PATIENT" :shareButton="false" :uploadButton="true" :vital-group="true" :vital-group-identifier="group.identifier" @fetchHistoricVitals="fetchHistoricVitals" :vital-group-display-name="group.displayName || ''"></patient-vital-card>
        </div>
      </div>

      <n-button type="primary" round style="position: fixed;bottom: 0px;left: 50%;transform: translate(-50%);z-index: 9999;" v-if="device && device.help && device.help.deviceHelp && Object.keys(device.help.deviceHelp).length > 0" @click.native="goTohelp(device.help.deviceHelp)">
        <i class="fas fa-info-circle"></i>
        Help
      </n-button>
    </div>
  </div>
</template>
<script>
import patientVitalCard from "../components/PatientVitalCard.vue";
import v8n from "v8n";
import { mapState } from "vuex";
import moment from "moment-timezone";

export default {
  name: "vitals",

  components: {
    patientVitalCard,
  },

  async mounted() {
    this.IS_PATIENT = this.user.roles.includes("patient");
    this.device = JSON.parse(
      JSON.stringify(this.$store.state.selectedMedicalDevice)
    );
    this.deviceProfile = this.$store.state.selectedDeviceProfile;
    //Clear scanned vitals data after populating
    this.$store.commit("setState", {
      stateName: "scannedDevices",
      stateValue: [],
    });

    try {
      this.historicVitals = await this.$store.dispatch("getVitalHistory", {
        patientId: this.patient.patientId,
        deviceProfile: this.deviceProfile,
        vitals: this.device.vitals,
        fromTime: moment().subtract(30, "days").unix() * 1000,
        toTime: moment().unix() * 1000,
      });
    } catch (e) {
      console.log(e);
    }

    if (this.device.vitalsGroup) {
      for (let vital of this.device.vitalsGroup) {
        let vitals = [];
        if (vital.vitals) {
          for (let _vital of vital.vitals) {
            let v = this.device.vitals.find(
              (element) => element.identifier == _vital
            );
            if (v) {
              vitals.push(v);
              /*               this.device.vitals = this.device.vitals.filter(
                (element) => element.identifier != _vital
              ); */
            }
          }
        }
        vital.vitals = vitals;
      }

      for (let vital of this.device.vitalsGroup) {
        if (vital.vitals) {
          for (let _vital of vital.vitals) {
            this.device.vitals = this.device.vitals.filter(
              (element) => element.identifier != _vital.identifier
            );
          }
        }
      }
    }

    this.showVitalsGroups = true;
    console.log(this.device);
  },

  data() {
    return {
      validatedVitalCount: 0,
      vitals: {
        deviceData: {},
      },
      errorMessages: {},
      historicVitals: null,
      deviceProfile: [],
      IS_PATIENT: false,
      device: null,
      showVitalsGroups: false,
    };
  },

  computed: {
    ...mapState({
      patient: "patient",
      scannedDevices: (state) => state.scannedDevices,
    }),
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },

    endpoint() {
      return this.$store.state.endpoint;
    },
  },

  methods: {
    async getDeviceProfile() {
      try {
        let deviceProfile = [];
        //get device profile from configurations
        let response = await this.$store.dispatch(
          "getConfigurationByEndpointId",
          {
            endpointId: this.endpoint._id,
            type: "deviceProfile",
          }
        );
        if (response && response.value) {
          deviceProfile = response.value;
        }

        this.$store.state.deviceProfile = deviceProfile;
        return this.$store.state.deviceProfile;
      } catch (e) {
        console.log(e);
        return [];
      }
    },

    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    validateReading(validationsMetadata, reading) {
      var validationResults = [];
      for (var i in Object.keys(validationsMetadata)) {
        var validationCheckRule = Object.keys(validationsMetadata)[i];
        var validationCheckValue = validationsMetadata[validationCheckRule];
        var v8nFunc = null;
        if (
          [
            "string",
            "number",
            "numeric",
            "integer",
            "boolean",
            "undefined",
            "null",
            "array",
            "object",
            "empty",
            "negative",
            "positive",
            "even",
            "odd",
          ].indexOf(validationCheckRule) > -1
        ) {
          if (validationCheckValue) {
            v8nFunc = v8n()[validationCheckRule]();
          } else {
            v8nFunc = v8n().not[validationCheckRule]();
          }
        } else if (["between"].indexOf(validationCheckRule) > -1) {
          var arg1 = validationCheckValue[0];
          var arg2 = validationCheckValue[1];
          v8nFunc = v8n()[validationCheckRule](arg1, arg2);
        } else if (validationCheckRule == "pattern") {
          var regex = new RegExp(
            validationCheckValue.substring(1, validationCheckValue.length - 2),
            validationCheckValue.charAt(validationCheckValue.length - 1)
          );
          v8nFunc = v8n()[validationCheckRule](regex);
        } else {
          v8nFunc = v8n()[validationCheckRule](validationCheckValue);
        }
        if (v8nFunc && !v8nFunc.test(reading.value)) {
          validationResults.push({
            validationCheckRule,
            validationCheckValue,
          });
        }
      }

      return validationResults;
    },
    goTohelp(help) {
      this.$store.commit("setState", {
        stateName: "vitalsHelp",
        stateValue: help,
      });
      this.$router.push("/vitalshelp");
    },
    async fetchHistoricVitals() {
      try {
        this.historicVitals = {};
        this.historicVitals = await this.$store.dispatch("getVitalHistory", {
          patientId: this.patient.patientId,
          deviceProfile: this.deviceProfile,
          vitals: this.device.vitals,
          fromTime: moment().subtract(30, "days").unix() * 1000,
          toTime: moment().unix() * 1000,
        });
      } catch (e) {
        console.log(e);
      }
    },
  },

  beforeDestroy() {
    this.deviceProfile.forEach((device) => {
      device.vitals.forEach((vital) => {
        vital.value = "";
      });
    });
  },
};
</script>
